__turbopack_context__.v({
  "BottomTagline": "_79FmVW_BottomTagline",
  "Buttons": "_79FmVW_Buttons",
  "CompanyStructure": "_79FmVW_CompanyStructure",
  "Content": "_79FmVW_Content",
  "ImageContainer": "_79FmVW_ImageContainer",
  "ImageGrid": "_79FmVW_ImageGrid",
  "Inline": "_79FmVW_Inline",
  "Invest": "_79FmVW_Invest",
  "Line": "_79FmVW_Line",
  "Lines": "_79FmVW_Lines",
  "Root": "_79FmVW_Root",
  "Sbr": "_79FmVW_Sbr",
  "Tagline": "_79FmVW_Tagline",
  "TaglineText": "_79FmVW_TaglineText",
  "Text": "_79FmVW_Text",
  "Title": "_79FmVW_Title",
  "TitleBottom": "_79FmVW_TitleBottom",
  "TitleContainer": "_79FmVW_TitleContainer",
  "TitleDesktop": "_79FmVW_TitleDesktop",
  "TitleMobile": "_79FmVW_TitleMobile",
  "TitleTop": "_79FmVW_TitleTop",
  "Visible": "_79FmVW_Visible",
  "Visit": "_79FmVW_Visit",
  "White": "_79FmVW_White",
});
